import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogHeader } from "$components/dialog/dialog-header";
import { WarningIcon } from "$components/icons";
import { styled, Typography } from "@material-ui/core";
import type { FC } from "react";
import { FormattedMessage } from "react-intl";

const HeaderWithIcon = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-start",
  gap: "16px",
  marginBottom: "16px",
}));

const ButtonContainer = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "24px",
}));

const StyledIcon = styled(WarningIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

interface NavigationConfirmationDialogProps {
  onContinue: () => void;
  onCancel: () => void;
  title?: string;
  bodyMessageId: string;
  bodyDefaultMessage: string;
}

export const NavigationConfirmationDialog: FC<
  NavigationConfirmationDialogProps &
    Omit<
      React.ComponentProps<typeof DialogContainer>,
      keyof NavigationConfirmationDialogProps
    >
> = ({
  onContinue,
  onCancel,
  title,
  bodyMessageId,
  bodyDefaultMessage,
  ...restProps
}) => {
  return (
    <DialogContainer {...restProps}>
      <HeaderWithIcon>
        <StyledIcon viewBox="0 0 32 32" fontSize="large" />
        <DialogHeader title={title} />
      </HeaderWithIcon>
      <DialogBody>
        <Typography color="textSecondary" paragraph>
          <FormattedMessage
            id={bodyMessageId}
            defaultMessage={bodyDefaultMessage}
          />
        </Typography>
        <ButtonContainer>
          <Button variant="text" color="primary" onClick={onContinue}>
            <FormattedMessage
              id="navigationConfirmationDialog.cancelButton"
              defaultMessage="Leave and discard data"
            />
          </Button>
          <Button variant="contained" color="primary" onClick={onCancel}>
            <FormattedMessage
              id="navigationConfirmationDialog.confirmButton"
              defaultMessage="Stay on this page"
            />
          </Button>
        </ButtonContainer>
      </DialogBody>
    </DialogContainer>
  );
};
